(function () {
    'use strict';

    angular.module('trakeyeApp').controller('DailySurveyReportController', DailySurveyReportController)
    angular.module('trakeyeApp').filter('trustFilter', ['$sce', function ($sce) {
        return function (text) {
            return $sce.trustAsHtml(text);
        };
    }]);

    DailySurveyReportController.$inject = ['$scope', '$sce', '$state', "Report", '$rootScope', '$timeout', '$window', '$filter', '$interval'];

    function DailySurveyReportController($scope, $sce, $state, Report, $rootScope, $timeout, $window, $filter, $interval) {
        var vm = this;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.reportTypeChange = reportTypeChanged;
        vm.users = [];

        vm.geofences = [];
        $scope.reporthide = false;
        vm.select2 = select2;
        var dateFormat = 'dd EEE hh:mm a';
        var date = "dd EEE";
        vm.fromTime = 0;
        vm.toTime = 0;
        vm.today = today();
        $scope.dailySurveyData = [];
        // vm.today();
        vm.select2();
        Report.getUsers('', function (response) {
            vm.users = response;

        })

        function today() {
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            vm.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }


        //vm.detailedReport = detailedReport;

        vm.selecterange = selectRange;
        vm.calculateToDate = calculateToDate;
        vm.calculateFromDate = calculateFromDate;
        function calculateFromDate() {

            vm.fromDate.setHours(0, 0, 0, 0);
            vm.fromTime = vm.fromDate.getTime();
        }
        function calculateToDate() {

            vm.toDate.setHours(23, 59, 59, 999);
            vm.toTime = vm.toDate.getTime();
        }
        function selectRange(range) {
            if (range == 'week') {
                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setDate(date.getDate() - 7)
                vm.fromTime = date.getTime();

            } else if (range == 'month') {

                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setMonth(date.getMonth() - 1);
                vm.fromTime = date.getTime();
            } else if (range == 'year') {

                var date = new Date();
                date.setHours(23, 59, 59, 999);
                vm.toTime = date.getTime();
                date.setHours(0, 0, 0, 0);
                date.setYear(date.getFullYear() - 1);
                vm.fromTime = date.getTime();
            }
        }
        function select2() {
            $(".select2").select2();
        }
        function reportTypeChanged() {
            $scope.reporthide = false;

            if (vm.users.length == 0) {
                Report.getUsers('', function (response) {
                    vm.users = response;
                })
            }


        }
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.modifiedDate = false;
        vm.datePickerOpenStatus.serviceDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.page = 1;
        vm.itemsPerPage = 25;
        vm.totalItems = 0;

        $scope.report = function (resetPage) {
            if (resetPage) {
                vm.page = 1;
            }

            var requestData = {
                startDate: vm.fromTime,
                endDate: vm.toTime,
                page: vm.page - 1,
                size: vm.itemsPerPage
            };

            Report.getDailyAssetSurveyReport(requestData, function (response, headers) {
                $scope.dailySurveyData = response.data;
                vm.totalItems = response.totalRecords;
            });
        };
        $scope.download = function () {
            $scope.loader = true;

            var allData = [];
            var page = 0;
            var size = vm.itemsPerPage;
            var firstRequestData = {
                startDate: vm.fromTime,
                endDate: vm.toTime,
                page: page,
                size: size
            };

            Report.getDailyAssetSurveyReport(firstRequestData, function (response) {
                var totalRecords = response.totalRecords;
                var totalPages = Math.ceil(totalRecords / size);

                allData = allData.concat(response.data);

                if (totalPages <= 1) {
                    createCSV(allData);
                    return;
                }
                fetchNextPage(page + 1, totalPages, allData);
            });

            function fetchNextPage(currentPage, totalPages, collectedData) {
                if (currentPage >= totalPages) {
                    createCSV(collectedData);
                    return;
                }

                var requestData = {
                    startDate: vm.fromTime,
                    endDate: vm.toTime,
                    page: currentPage,
                    size: vm.itemsPerPage
                };

                Report.getDailyAssetSurveyReport(requestData, function (response) {
                    collectedData = collectedData.concat(response.data);
                    fetchNextPage(currentPage + 1, totalPages, collectedData);
                });
            }
            function createCSV(data) {
                $scope.loader = false;

                if (!data || data.length === 0) {
                    alert("No data found for the selected range.");
                    return;
                }

                var csvRows = [];
                var headers = [
                    "Sl No",
                    "Created Date",
                    "Updated Date",
                    "Asset Name",
                    "Asset Type Name",
                    "First Name",
                    "Last Name",
                    "Block Name",
                    "District Name",
                    "Status",
                    "Progress"
                ];
                csvRows.push(headers.join(","));

                for (var i = 0; i < data.length; i++) {
                    var asset = data[i];
                    var progress = "N/A";
                    if (asset.status === "Completed") progress = "100%";
                    else if (asset.status === "In Progress") progress = "50%";
                    else if (asset.status === "Not Started") progress = "0%";

                    var createdDate = formatDate(asset.createDate);
                    var updatedDate = formatDate(asset.updateDate);
                    var row = [
                        (i + 1),
                        escapeCSV(createdDate),
                        escapeCSV(updatedDate),
                        escapeCSV(asset.assetName),
                        escapeCSV(asset.assetTypeName),
                        escapeCSV(asset.firstName),
                        escapeCSV(asset.lastName),
                        escapeCSV(asset.blockName),
                        escapeCSV(asset.district),
                        escapeCSV(asset.status),
                        escapeCSV(progress)
                    ];
                    csvRows.push(row.join(","));
                }

                var csvString = csvRows.join("\n");
                var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
                var link = document.createElement("a");
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", "DailySurveyReport.csv");
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            function escapeCSV(value) {
                if (value == null) return "";
                var str = value.toString().replace(/"/g, '""');
                if (str.search(/("|,|\n)/g) >= 0)
                    str = '"' + str + '"';
                return str;
            }
            function formatDate(epoch) {
                if (!epoch) return "";
                var date = new Date(epoch);
                var day = ("0" + date.getDate()).slice(-2);
                var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                var month = monthNames[date.getMonth()];
                var year = date.getFullYear();
                var hours = ("0" + date.getHours()).slice(-2);
                var minutes = ("0" + date.getMinutes()).slice(-2);
                var seconds = ("0" + date.getSeconds()).slice(-2);
                return day + "-" + month + "-" + year + " " + hours + ":" + minutes + ":" + seconds;
            }
        };
 

    }

})();
